import React from "react"

import Breadcrumb from "components/Common/Breadcrumb"
import {
  CardBody,
  Col,
  Container,
  Input,
  Row,
  Card,
  Label,
  Table,
} from "reactstrap"
import { toast } from "react-toastify"
import { useHistory, useLocation } from "react-router-dom"
import SelectBox from "components/Common/SelectBox"
import SButton from "components/Common/Button"
import { useDispatch, useSelector } from "react-redux"
import { getProductCategoryList } from "store/actions"
import {
  getProductByIdAPI,
  postProductAPI,
  putProductAPI,
} from "helpers/product_helper"
import BackButton from "components/Common/BackButton"
import { getOrderSheetByIdAPI } from "helpers/order_sheet"

function ProductManagement() {
  const history = useHistory()
  const dispatch = useDispatch()
  const categoryList = useSelector(
    ({ productCategory }) => productCategory?.list
  )

  let location = useLocation()

  const params = new URLSearchParams(location.search)
  const id = params.get("id")

  const [formState, setFormState] = React.useState("create")

  const [field, setField] = React.useState({
    categoryId: 0,
    productName: "",
  })

  const [pantsDimension, setPantsDimension] = React.useState([])
  const [jacketDimension, setJacketDimension] = React.useState([])

  // const [countPants, setCountPants] = React.useState(1)

  const [dimensionsP, setDimensionsP] = React.useState([])
  const [dimensionsJ, setDimensionsJ] = React.useState([])

  const [customValidation, setCustomValidation] = React.useState({
    errorCategoryId: {
      status: false,
      message: "カテゴリ名 必須項目です",
    },
    errorProductName: {
      status: false,
      message: "商品名 必須項目です",
    },
  })

  const onSubmit = async () => {
    let error = 0
    let defaultError = { ...customValidation }

    if (field.categoryId === 0 || !field.categoryId) {
      defaultError = {
        ...defaultError,
        errorCategoryId: { ...defaultError.errorCategoryId, status: true },
      }

      error += 1
    }
    if (field.productName === "" || !field.productName) {
      defaultError = {
        ...defaultError,
        errorProductName: { ...defaultError.errorProductName, status: true },
      }

      error += 1
    }
    setCustomValidation(defaultError)

    if (error === 0) {
      try {
        if (formState === "create") {
          await postProductAPI(field)
        } else {
          const temp = { ...field }

          const tempPants = [],
            tempJacket = []

          if (temp?.pants?.tgs) {
            temp?.pants?.tgs.forEach(pTG => {
              if (pTG.tg !== "") {
                tempPants.push(pTG)
              }
            })
            temp.pants.tgs = tempPants
          }

          if (temp?.jacket?.tgs) {
            temp?.jacket?.tgs.forEach(jTG => {
              if (jTG.tg !== "") {
                tempJacket.push(jTG)
              }
            })
            temp.jacket.tgs = tempJacket
          }

          await putProductAPI(temp, id)
        }

        history.push("/master/product")
      } catch (err) {
        let {
          data: { errors },
        } = err?.response
        if (errors) {
          errors.forEach(err => {
            let entries = Object.entries(err)
            entries.map(([key] = entry) => {
              return toast.error(`[${key}]: 必須項目です。`)
            })
          })
        }
      }
    }
  }

  React.useEffect(() => {
    dispatch(getProductCategoryList())
  }, [id])

  const getOne = async () => {
    if (id) {
      setFormState("edit")
      const res = await getProductByIdAPI(id)
      let _field = {
        ...res.data,
        productName: res.data.productName,
        categoryId: res.data.categoryId,
      }

      const resOrderSheetByID = await getOrderSheetByIdAPI(id)
      if (resOrderSheetByID?.data?.jacket?.dimensions) {
        setJacketDimension(
          [{ item: "tg" }].concat(resOrderSheetByID.data.jacket.dimensions)
        )
      }

      if (resOrderSheetByID?.data?.pants?.dimensions) {
        setPantsDimension(
          [{ item: "tg" }].concat(resOrderSheetByID.data.pants.dimensions)
        )
      }

      // ini pertama kali tidak ada data pants di product by id
      if (resOrderSheetByID.data.pants || res.data.pants) {
        let pants = {}
        let tgs = []

        if (!res.data.pants) {
          for (let i = 0; i < 1; i++) {
            const dimensions = []

            resOrderSheetByID.data.pants.dimensions.forEach(pD => {
              dimensions.push({
                formId: pD.formId,
                item: pD.item,
                sequence: pD.sequence,
                defaultValue: "",
              })
            })
            tgs.push({
              tg: "",
              values: dimensions,
            })

            setDimensionsP(dimensions)
          }
          if (tgs.length > 0) {
            pants.tgs = tgs
          } else {
            pants = null
          }
          _field = { ..._field, pants }
        } else {
          const dimensions = []

          resOrderSheetByID.data.pants.dimensions.forEach(pD => {
            dimensions.push({
              formId: pD.formId,
              item: pD.item,
              sequence: pD.sequence,
              defaultValue: "",
            })
          })

          setDimensionsP(dimensions)
        }
      }
      if (resOrderSheetByID.data.jacket || res.data.jacket) {
        let jacket = {}
        const tgs = []

        if (!res.data.jacket) {
          for (let i = 0; i < 1; i++) {
            const dimensions = []

            resOrderSheetByID.data.jacket.dimensions.forEach(pD => {
              dimensions.push({
                formId: pD.formId,
                item: pD.item,
                sequence: pD.sequence,
                defaultValue: "",
              })
            })
            tgs.push({
              tg: "",
              values: dimensions,
            })
            setDimensionsJ(dimensions)
          }
          if (tgs.length > 0) {
            jacket.tgs = tgs
          } else {
            jacket = null
          }
          _field = { ..._field, jacket }
        } else {
          const dimensions = []

          resOrderSheetByID.data.jacket.dimensions.forEach(pD => {
            dimensions.push({
              formId: pD.formId,
              item: pD.item,
              sequence: pD.sequence,
              defaultValue: "",
            })
          })

          setDimensionsJ(dimensions)
        }
      }

      setField({ ..._field })
    }
  }

  React.useEffect(() => {
    getOne()
  }, [id])

  const categoryOption =
    categoryList.length > 0 &&
    categoryList
      ?.filter(a => a.name !== "")
      .map(v => ({
        value: v?.id,
        label: v?.name,
      }))

  const categoryValue =
    categoryList.length > 0 &&
    categoryOption.find(val => val.value === field.categoryId)

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"商品マスター"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={8}>
                <p className="fw-bold">
                  {id ? "商品マスター詳細" : "新規商品マスター追加"}
                </p>
              </Col>
              <Col className="d-flex justify-content-end">
                <SButton onClick={onSubmit} className="button">
                  保存
                </SButton>
                <BackButton className="ms-2 button" />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={12}>
                <Row>
                  <Col md={2} className="col-form-label">
                    <Label className="form-label">
                      カテゴリ名<span className="text-danger">*</span>
                    </Label>
                  </Col>
                  <Col md={6}>
                    <SelectBox
                      onChange={e => {
                        setField({ ...field, categoryId: e?.value })
                        setCustomValidation({
                          ...customValidation,
                          errorCategoryId: {
                            ...customValidation.errorCategoryId,
                            status: false,
                          },
                        })
                      }}
                      value={categoryValue}
                      defaultValue={categoryValue}
                      options={categoryOption}
                    />
                  </Col>
                </Row>
                {customValidation.errorCategoryId.status && (
                  <Row>
                    <Col md={2}></Col>
                    <Col md={10}>
                      <p style={{ color: "red" }}>
                        {customValidation.errorCategoryId.message}
                      </p>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col md={2} className="col-form-label">
                    <Label className="form-label">
                      商品名<span className="text-danger">*</span>
                    </Label>
                  </Col>
                  <Col md={6}>
                    <Input
                      name="name"
                      value={field.productName}
                      onChange={e => {
                        setField({ ...field, productName: e.target.value })
                        setCustomValidation({
                          ...customValidation,
                          errorProductName: {
                            ...customValidation.errorProductName,
                            status: false,
                          },
                        })
                      }}
                    />
                  </Col>
                </Row>
                {customValidation.errorProductName.status && (
                  <Row>
                    <Col md={2}></Col>
                    <Col md={10}>
                      <p style={{ color: "red" }}>
                        {customValidation.errorProductName.message}
                      </p>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
        {field?.pants && (
          <Card>
            <h4 className="m-3">トラウザーズ</h4>
            <CardBody>
              <Table
                className="p-3"
                bordered
                responsive
                style={{ whiteSpace: "nowrap" }}
              >
                <tbody>
                  {pantsDimension &&
                    pantsDimension.map((pD, index) => (
                      <tr key={index}>
                        <td style={{ width: "10px" }}>{pD?.item}</td>
                        {index === 0
                          ? field?.pants?.tgs.map((pants, i) => (
                              <td style={{ width: "20px" }} key={i}>
                                <input
                                  value={pants.tg}
                                  onChange={e => {
                                    const temp = [...field?.pants?.tgs]
                                    temp[i].tg = e.target.value
                                    setField({ ...field, pants: { tgs: temp } })
                                  }}
                                  onBlur={() => {
                                    const temp = [...field?.pants?.tgs]
                                    let checkingTg = true
                                    if (field?.pants?.tgs) {
                                      field?.pants?.tgs.forEach(pTG => {
                                        if (pTG.tg === "") {
                                          checkingTg = false
                                        }
                                      })
                                      if (checkingTg) {
                                        temp.push({
                                          tg: "",

                                          values: dimensionsP,
                                        })
                                        setField({
                                          ...field,
                                          pants: { tgs: temp },
                                        })
                                      }
                                    }
                                  }}
                                />
                              </td>
                            ))
                          : ""}

                        {field?.pants?.tgs.map((pants, indexP) => (
                          <>
                            {pants.values.map((pV, i) => (
                              <>
                                {i + 1 === index &&
                                  pD.item !== "tg" && ( // kalo id nya gak sama harusnya pakek ini pV.formId === pD.formId
                                    <td style={{ width: "20px" }} key={i}>
                                      <input
                                        value={pV.defaultValue}
                                        onChange={e => {
                                          const temp = JSON.parse(
                                            JSON.stringify([
                                              ...field?.pants?.tgs,
                                            ])
                                          )

                                          temp[indexP].values[i].defaultValue =
                                            e.target.value

                                          setField({
                                            ...field,
                                            pants: { tgs: temp },
                                          })
                                        }}
                                      />
                                    </td>
                                  )}
                              </>
                            ))}
                          </>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        )}
        {field?.jacket && (
          <Card>
            <h4 className="m-3">上着</h4>
            <CardBody>
              <Table
                className="p-3"
                bordered
                responsive
                style={{ whiteSpace: "nowrap" }}
              >
                <tbody>
                  {jacketDimension &&
                    jacketDimension.map((pD, index) => (
                      <tr key={index}>
                        <td style={{ width: "10px" }}>{pD.item}</td>
                        {index === 0
                          ? field?.jacket?.tgs.map((jacket, i) => (
                              <td style={{ width: "10px" }} key={i}>
                                <input
                                  value={jacket.tg}
                                  onChange={e => {
                                    const temp = [...field?.jacket?.tgs]
                                    temp[i].tg = e.target.value
                                    setField({
                                      ...field,
                                      jacket: { tgs: temp },
                                    })
                                  }}
                                  onBlur={() => {
                                    const temp = [...field?.jacket?.tgs]
                                    let checkingTg = true
                                    if (field?.jacket?.tgs) {
                                      field?.jacket?.tgs.forEach(pTG => {
                                        if (pTG.tg === "") {
                                          checkingTg = false
                                        }
                                      })
                                    }

                                    if (checkingTg) {
                                      temp.push({
                                        tg: "",
                                        values: dimensionsJ,
                                      })
                                      setField({
                                        ...field,
                                        jacket: { tgs: temp },
                                      })
                                    }
                                  }}
                                />
                              </td>
                            ))
                          : ""}

                        {field?.jacket?.tgs.map((jacket, indexP) => (
                          <>
                            {jacket.values.map((pV, i) => (
                              <>
                                {i + 1 === index &&
                                  pD.item !== "tg" && ( // kalo id nya gak sama harusnya pakek ini pV.formId === pD.formId
                                    <td style={{ width: "10px" }}>
                                      <input
                                        value={pV.defaultValue}
                                        name="defaultValue"
                                        onChange={e => {
                                          const temp = JSON.parse(
                                            JSON.stringify([
                                              ...field?.jacket?.tgs,
                                            ])
                                          )
                                          temp[indexP].values[i].defaultValue =
                                            e.target.value

                                          setField({
                                            ...field,
                                            jacket: { tgs: temp },
                                          })
                                        }}
                                      />
                                    </td>
                                  )}
                              </>
                            ))}
                          </>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        )}
      </Container>
    </div>
  )
}

export default ProductManagement
